import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from '../../../config/store';
import {serverAPIUrl} from "../../../services/api";


export interface FormReviewProp {
    id?: number
    branch: number
    name?: string
    phone?: string
    email?: string
    text?: string,
    image?: any
}

export const saveFormReview = createAsyncThunk(
    'about/review',
    async (data: FormReviewProp, thunkAPI) => {
        const state = thunkAPI.getState() as RootState;
        let formData = new FormData()
        for(const name in data) {
            // @ts-ignore
            if (name!='image'){
                // @ts-ignore
                formData.append(name, data[name]);
            }else{
                // @ts-ignore
                const f = data[name][0]
                if (f){
                    formData.append(name, f);
                }

            }

          }
        try {
            const response = await fetch(`${serverAPIUrl}about/review/`, {
                method: 'POST',
                body: formData,
            })

            const responseData = await response.json();

            if (response.status != 201) {
                return thunkAPI.rejectWithValue(responseData)
            } else {
                return thunkAPI.fulfillWithValue(responseData)
            }
        } catch (err) {
            return thunkAPI.rejectWithValue({serverError: err.toString()})
        }
    }
)

interface InitialState {
    data: any;
    error: any
}

const initialState: InitialState = {
    data: {
        id: null,
        name: '',
    },
    error: [],
}

export const formReviewSlice = createSlice({
    name: 'formreview',
    initialState: initialState,
    reducers: {
        resetReviewForm: (state: any) => {
            state.data = initialState;
            state.error = []
        },
    },
    extraReducers: (builder) => {
        builder.addCase(saveFormReview.fulfilled, (state: any, action: any) => {
            state.data = action.payload;
            state.error = []
        }).addCase(saveFormReview.rejected, (state: any, action: any) => {
            state.error = action.payload;
        })
    },
});

export const {
    resetReviewForm
} = formReviewSlice.actions;

export const selectFormReview = (state: RootState) => state.formreview;

export default formReviewSlice.reducer;